export const portfolioPageDataArabic = {
  banner: {
    backgroundImage: "/images/portfolio-banner-bg-image.png",
    mainHeading: "عملنا، عيونكم، إنها قصة حب",
    content: "نحن نصنع الفارق بمعدات أفضل وتفانٍ",
    contactUsLink: "/contact-us",
    buttonText: "هيا نتواصل",
  },
  seo: {
    title: "المعرض | استكشف مشاريع Bitsclan البرمجية الناجحة",
    description: "اكتشف مجموعة Bitsclan المتنوعة من مشاريع تطوير البرمجيات الناجحة عبر الصناعات. تعرف على كيف نقدم القيمة والابتكار.",
  },
  developingSolution: {
    heading: "عملاء يثقون بنا في أمنهم",
  },
};